import React, { Component } from 'react'
import LoadingOverlay from '../../components/loading/loading';
import { toast } from "react-toastify";
import service from '../../services/service';

class HotelForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            rating: "",
            pricePerNight: "",
            address: "",
            amenities: "",
            description: "",
            loading: false,
            images: [],
            uploadedImages: [],
            updateFields: {},
        };
    }

    componentDidMount() {
        if (this.props.hotel_id !== "false") {
            this.getHotelDetails();
        }
    }

    changeHandler = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === "amenities") {
            // Split the input string into an array and update the `updateFields`
            this.setState((prevState) => ({
                updateFields: {
                    ...prevState.updateFields,
                    [name]: value.split(",").map(item => item.trim()), // Split by commas and trim any extra spaces
                },
            }));
        } else {
            this.setState((prevState) => ({
                updateFields: {
                    ...prevState.updateFields,
                    [name]: value,
                },
            }));
        }
    }

    // Handle file selection
    handleFileChange = (e) => {
        this.setState({ images: e.target.files });
    };

    getHotelDetails = async () => {
        if (this.props.hotel_id !== "false") {
            try {
                this.setState({ loading: true });
                const hotel_id = this.props.hotel_id;
                const hotelDetail = await service.view("hotels/" + hotel_id);
                if (hotelDetail && !hotelDetail.success) {
                    toast.error(hotelDetail.message);
                    return;
                }

                this.setState({
                    name: hotelDetail.hotel.name || "",
                    rating: hotelDetail.hotel.rating || "",
                    pricePerNight: hotelDetail.hotel.pricePerNight || "",
                    address: hotelDetail.hotel.address || "",
                    amenities: hotelDetail.hotel.amenities ? hotelDetail.hotel.amenities.join(", ") : "",
                    description: hotelDetail.hotel.description || "",
                });

            } catch (error) {
                toast.error(error.message);
            } finally {
                this.setState({ loading: false });
            }
        }
    }

    submitHandler = async (e) => {
        e.preventDefault();
        try {
            this.setState({ loading: true });

            const hotel_id = this.props.hotel_id;

            // Prepare the amenities array and other fields for submission
            const amenitiesArray = this.state.amenities.split(",").map(item => item.trim());

            // Use FormData to handle both text data and files
            const formData = new FormData();
            formData.append("name", this.state.name);
            formData.append("rating", this.state.rating);
            formData.append("pricePerNight", this.state.pricePerNight);
            formData.append("address", this.state.address);
            formData.append("description", this.state.description);
            formData.append("amenities", amenitiesArray);

            // Append images to FormData
            Array.from(this.state.images).forEach((file) => {
                formData.append("images", file);
            });

            if (hotel_id !== "false") {
                const response = await service.saveWithFile(formData, `hotels/update/${hotel_id}`, "PUT");
                if (response && !response.success) {
                    toast.error(response.message + ": " + response.displayMessage);
                    return;
                }
    
                toast.success(response.message + ": " + response.displayMessage);
            } else {
                // Create a new hotel
                const response = await service.saveWithFile(formData, "hotels/create", "POST");
                if (response && !response.success) {
                    toast.error(response.message + ": " + response.displayMessage);
                    return;
                }
    
                toast.success(response.message + ": " + response.displayMessage);
            }
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { name, rating, pricePerNight, address, amenities, description, loading } = this.state;

        return (
            <>
                {loading && <LoadingOverlay />}
                <form onSubmit={this.submitHandler} className="contact-form">
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Hotel Name</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={name}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="name"
                                    placeholder="e.g. Marine Hotel"
                                />
                            </div>
                        </div>
                        <div className="col-lg-1 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Ratings</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={rating}
                                    onChange={this.changeHandler}
                                    type="number"
                                    min={0}
                                    name="rating"
                                    placeholder="e.g. 4.5"
                                />
                            </div>
                        </div>
                        <div className="col-lg-2 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Price Per Night</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={pricePerNight}
                                    onChange={this.changeHandler}
                                    type="number"
                                    min={0}
                                    name="pricePerNight"
                                    placeholder="e.g. 10000"
                                />
                            </div>
                        </div>
                        <div className="col-lg-5 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Address</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={address}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="address"
                                    placeholder="e.g. Sutton Cross, Dublin, D13, Ireland"
                                />
                            </div>
                        </div>
                        <div className="col-lg-12 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Description</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={description}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="description"
                                    placeholder="Descibe"
                                />
                            </div>
                        </div>
                        <div className="col-lg-10 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Amenities</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={amenities}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="amenities"
                                    placeholder="e.g. Free Wi-Fi, Indoor pool, 24-hour front desk"
                                />
                            </div>
                        </div>
                        <div className="col-lg-10 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Upload Images</label>
                                <input type="file" multiple onChange={this.handleFileChange} />
                            </div>
                        </div>
                        <div className="col-lg-1 col-12 text-end">
                            <div className="form-field">
                                <button type="submit" className="theme-btn" style={{ padding: '10px 40px', marginTop: '28px' }}>
                                    {this.props.hotel_id !== "false" ? "Update" : "Add"}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </>
        )
    }
}
export default HotelForm;